import { render, staticRenderFns } from "./LogoutSuccess.vue?vue&type=template&id=4a03da69&scoped=true&"
var script = {}
import style0 from "./LogoutSuccess.vue?vue&type=style&index=0&id=4a03da69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a03da69",
  null
  
)

export default component.exports